import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CheckCircle2, XCircle } from 'lucide-react';
export function WhoThisIsFor() {
  return <section className="py-20 px-4 bg-white" data-id="element-168">
      <div className="max-w-4xl mx-auto" data-id="element-169">
        <FadeIn data-id="element-170">
          <h2 className="text-3xl md:text-4xl font-bold text-navy-800 mb-12 text-center" data-id="element-171">
            Who This Is For (And Why It Exists)
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-12" data-id="element-172">
          <FadeIn delay={100} data-id="element-173">
            <div className="bg-blue-50 p-8 rounded-xl h-full border border-blue-100" data-id="element-174">
              <h3 className="text-xl font-bold text-navy-800 mb-6 flex items-center" data-id="element-175">
                <CheckCircle2 className="text-teal-600 mr-3 h-6 w-6" data-id="element-176" />
                This Is For You If:
              </h3>
              <ul className="space-y-4" data-id="element-177">
                {["You're new to CPAP (or restarting) and your nights feel chaotic", 'You wake up with dry mouth, a sore nose, or air blasting from leaks', 'You feel that creeping shame: "Why can\'t I tolerate this?"', "You're stressed about compliance hours and you're tired of guessing"].map((item, i) => <li key={i} className="flex items-start text-lg-body text-text-body" data-id="element-178">
                    <span className="mr-3 mt-2 block w-1.5 h-1.5 rounded-full bg-teal-600 flex-shrink-0" data-id="element-179" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          <FadeIn delay={200} data-id="element-180">
            <div className="bg-gray-50 p-8 rounded-xl h-full border border-gray-100" data-id="element-181">
              <h3 className="text-xl font-bold text-navy-800 mb-6 flex items-center" data-id="element-182">
                <XCircle className="text-amber-500 mr-3 h-6 w-6" data-id="element-183" />
                This Is NOT For You If:
              </h3>
              <ul className="space-y-4" data-id="element-184">
                <li className="flex items-start text-lg-body text-text-body" data-id="element-185">
                  <span className="mr-3 mt-2 block w-1.5 h-1.5 rounded-full bg-amber-500 flex-shrink-0" data-id="element-186" />
                  You want a "biohacking sleep guide."
                </li>
              </ul>
              <div className="mt-8 pt-8 border-t border-gray-200" data-id="element-187">
                <p className="text-lg-body font-medium text-navy-800 italic" data-id="element-188">
                  This is for the man who just wants to sleep… and wake up
                  feeling like himself again.
                </p>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}